/**
 * Error reporting (Sentry). Import this first in main.jsx.
 * Set VITE_SENTRY_DSN in env to enable; no DSN = no-op (no PII sent).
 */

import * as Sentry from '@sentry/react'

const dsn = typeof import.meta !== 'undefined' && import.meta.env?.VITE_SENTRY_DSN

if (dsn) {
  if (import.meta.env?.DEV) {
    console.log('[Sentry] Initializing with DSN (errors will be sent to sentry.io)')
  }
  Sentry.init({
    dsn,
    environment: typeof import.meta !== 'undefined' ? import.meta.env?.MODE ?? 'development' : 'production',
    // No PII: don't send default headers that might include IP/user agent details beyond what's needed
    sendDefaultPii: false,
    beforeSend(event, _hint) {
      // Strip any PII that might have been attached
      if (event.user) {
        delete event.user.email
        delete event.user.ip_address
      }
      if (event.request?.headers) {
        const safe = {}
        const allow = ['user-agent', 'content-type']
        allow.forEach((k) => {
          if (event.request.headers[k]) safe[k] = event.request.headers[k]
        })
        event.request.headers = safe
      }
      return event
    },
    ignoreErrors: [
      // Benign or noisy
      'ResizeObserver loop',
      'Non-Error promise rejection captured',
    ],
  })

  // Unhandled promise rejections
  window.addEventListener('unhandledrejection', (ev) => {
    Sentry.captureException(ev.reason)
  })
} else if (typeof import.meta !== 'undefined' && import.meta.env?.DEV) {
  console.warn('[Sentry] Not initializing: VITE_SENTRY_DSN is not set in .env. Add it to send errors to Sentry.')
}

export { Sentry }
